import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import RichText from '@/app/components/RichText';
import TwoColumnModule from '@/app/components/TwoColumnModule';

import { motionProps, textCol } from '../_data/membershipTwoModuleData';

const MembershipSection = () => {
  const t = useTranslations();
  return (
    <section>
      <TypographyV3
        className="px-6 py-10 text-center text-4xl font-light md:text-6xl"
        data-cy="membership-section-title"
      >
        <RichText
          messageKey="ring_pdp_2025_membership_section_title"
          tValues={{
            em: (chunks: ReactNode) => (
              <em className="font-serif italic">{chunks}</em>
            ),
          }}
        />
      </TypographyV3>
      <div className="px- py-6 lg:py-20" data-cy="membership-two-col-module">
        <TwoColumnModule
          imageCol={{
            localizedAlt: 'pop_gen4_long_term_health_img_alt',
            src: t('pop_gen4_long_term_health_img_src'),
            motionProps,
          }}
          layoutGridClassName="lg:gap-y-12 gap-y-6"
          textCol={textCol}
          mdBreakTextPos="right"
        />
      </div>
    </section>
  );
};
export default MembershipSection;
